import React, { useState } from "react";
import Reporting from "../components/Reporting";

const faqList = [
  {
    id: 1,
    question: "What is ESG reporting software and how does it help businesses?",
    answer:
      "An ESG reporting software like UpdaptESG offers a holistic platform to streamline data collection, monitoring and tracking for reporting disclosures aligned to various international standards, frameworks and guidelines. It helps businesses to create a unified database for their ESG and sustainability related data for reporting to ESRS, AASB, BRSR, TCFD, SASB, CDP, UN SDGs, UN PRI, among others.",
  },
  {
    id: 2,
    question: "How does Updapt streamline ESG reporting across frameworks?",
    answer:
      "UpdaptESG streamlines the data collection process for ESG disclosures for reporting across various frameworks. Leveraging the AI-ML capabilities of the solution, companies can create customized reports, ESG performance reports which can be aligned to  ESRS, AASB, BRSR, TCFD, SASB, CDP, UN SDGs, UN PRI, among others and relevant company data for a particular time period across the organizational hierarchy, assets and locations. Granular data disclosures that are collected in the platform can also be translated into customizable, user friendly dashboards, analytics and trends to monitor the sustainability journey and progress of the organization.",
  },
  {
    id: 3,
    question:
      "Can the software generate reports aligned with CSRD, TCFD, and CDP?",
    answer:
      "Yes, the software can generate reports aligned with CSRD, TCFD, and CDP among other global and regional sustainability-related standards, frameworks, guidelines and principles. The software offers custom reports, ESG performance reports, peer benchmarking, AI-ML driven analytics, gap assessment, trend analysis and peer insights.",
  },
  {
    id: 4,
    question: "Is Updapt suitable for multinational ESG compliance?",
    answer:
      "Yes, Updapt is extremely suitable for multinational ESG compliance based on industry and sector requirements. The highly configurable software caters to multi-user, multi-entity, multi-geographic data collection and tracking, enabling cross-border and cross-departmental collation and harmony for data monitoring.",
  },
  {
    id: 5,
    question:
      "Can reports be customized for different audiences (investors, boards, regulators)?",
    answer:
      "Yes, reports can be customized and generated within the software for different audiences with KPI level granularity and data selection flexibility. Various users (investors, board members, regulators, team employees) can generate and download reports for internal and external consumption.",
  },
  {
    id: 6,
    question: "How are narrative disclosures and data visualizations managed?",
    answer:
      "Narrative disclosures in reporting requirements can be filled using Updapt’s in-house UpSage AI for qualitative response generation. Our smart AI is trained to collate relevant ESG and sustainability related information for an organization pertaining to their performance, industry best practices and strategies. Data visualization in the software is available across all ESG KPIs as per the organization’s requirements, to slice and dice the data across locations, business verticals, grouping systems, products and services, and time period. Customizable graphs and charts can be generated for visual representation of the organization’s database and performance for trend analysis and monitoring.",
  },
  {
    id: 7,
    question: "What export formats are available for ESG reports?",
    answer:
      "ESG performance reports can be downloaded in a word and excel format. BRSR reports can be downloaded as per SEBI’s mandates in an XBRL format for direct submission, or a word document for business inputs. As per the European reporting disclosure requirements, reports can also be downloaded in the European Single Electronic Format (ESEF). The platform’s report builder will cater to all global standards and frameworks with export formats as per the submission requirements.",
  },
  {
    id: 8,
    question:
      "Does the software support scheduling and automated report generation?",
    answer:
      "Yes, the software supports scheduling the report generation across Environmental, Social and Governance topics with automated reports that can be shared with various users at a scheduled time period. ",
  },
  {
    id: 9,
    question: "How does Updapt ensure data consistency across reports?",
    answer:
      "Updapt ensures consistency by creating “one source of truth” for ESG data, Centralized Data Architecture, Standardized Data Collection & Validation, Version Control & Audit Trails, Framework Mapping (Multi-Reporting Alignment), Automated Report Generation, Governance & Approval Workflows, and Integration with External Data Sources.",
  },
  {
    id: 10,
    question: "Can multiple users collaborate on ESG reports securely?",
    answer:
      "Yes, the software can be accessed by multiple users to collaborate on ESG reports securely, through multi-user based access roles that can be predefined by the organization. ",
  },
  {
    id: 11,
    question: "Is there version tracking and approval workflow for reporting?",
    answer:
      "Yes, Updapt has built-in version tracking and approval workflows to keep reporting clean and reliable. Every change to data or reports is logged with timestamps and user IDs, so you always know who updated what. Reports move through a maker–checker style review process, where different roles handle data entry, review, and final approval. This ensures only validated and approved information gets published, creating a single source of truth. The result is consistent, audit-ready reporting that reduces errors and greenwashing risks.",
  },
  {
    id: 12,
    question: "How frequently can reports be updated or revised?",
    answer:
      "In Updapt, reports can be updated or revised as frequently as the organization needs—there’s no fixed limit. Data updates (like energy use, emissions, or HR metrics) can be uploaded in real time, monthly, quarterly, or annually depending on the source and reporting requirements. Reports themselves can be revised anytime, but each revision is version-controlled so earlier versions remain traceable. Many clients use quarterly refreshes for management dashboards and annual cycles for regulatory disclosures (e.g., CSRD, BRSR). For ongoing stakeholder needs, live dashboards can update continuously, while the official “published” report is locked once approved. Data lock features and controls help in maintaining data integrity and validation. ",
  },
  {
    id: 13,
    question: "Does the tool support audit-ready reporting templates?",
    answer:
      "Yes, the software supports audit-ready reporting templates that can be downloaded directly for internal and external purposes. User based access roles can be provided for auditors and assurers for data validation, approvals and reporting requirements. ",
  },
  {
    id: 14,
    question: "How does Updapt support ESG reporting for different sectors?",
    answer:
      "Updapt supports ESG reporting by adapting to the specific needs of each sector while ensuring compliance with global and local disclosure frameworks. Instead of a one-size-fits-all model, the platform maps sector-specific KPIs into recognized standards like SASB, CSRD, BRSR, and TCFD. Updapt acts as a flexible, highly configurable multi-framework ESG engine, with tailored metrics and reporting workflows to the hierarchy of each industry while maintaining consistent, comparable and audit-ready data.",
  },
];

function ReportingContainer() {
  // const [whyFeatures] = useState([
  //   {
  //     header: "A centralized ESG data management and decision-making solution",
  //     desc:
  //       "Tracking, analysing and consolidating ESG data on a spreadsheet from different locations can be a time-consuming and error prone activity. U-Data Track provides a single interface that comprehends all company wide ESG data accurately to support effective decision-making and gives you time to focus on the task of value creation.",
  //   },
  //   {
  //     header: "Monitor and record your GHG emissions with precision",
  //     desc:
  //       "Today, investors, governments and communities demand greater accuracy, transperancy and action on accounting for greenhouse gas emissions from various sectors.U-Data track, with its vast repository of  globally recognised emission data and the ability to translate all energy related data to total GHG emissions with one click is a tailor made solution for emission reporting.",
  //   },
  //   {
  //     header:
  //       "Not just the E of ESG, but also monitor and report the S and G aspects effortlessly",
  //     desc:
  //       "Collating and deriving key performance indicators related to employee health and safety, supplier screening and compliance with ESG policies, community support are also crucial factors of ESG. U-Data Track provides you the dedicated modules to manage H&S metrics, supplier compliance and community funding projects.",
  //   },
  //   {
  //     header:
  //       "Intuitive leadership dashboards for data driven decision making.",
  //     desc:
  //       "To drive a successful sustainability management sytem, it is critical to have a holistic view of the organisation's ESG performance. This equips leaders to make sound decisions. U-Data track provides a customised dashboard for all aspects of ESG, from energy, water, waste, emissions to employee H&S.",
  //   },
  // ]);
  return <Reporting faqList={faqList}></Reporting>;
}

export default ReportingContainer;
